// src/utils/apiFetch.js

// Wrapper around native fetch() that automatically attaches the
// current org name (X-Org-Name header), the same way axios's
// interceptor in index.js does for axios calls. Use this instead of
// calling fetch() directly anywhere in the app, so every request —
// axios or fetch — correctly reaches the right organization's database.
export function apiFetch(url, options = {}) {
  const orgName = localStorage.getItem("saved_orgname");
  return fetch(url, {
    ...options,
    headers: {
      ...(options.headers || {}),
      ...(orgName ? { "X-Org-Name": orgName } : {}),
    },
  });
}